import state from '~store/modules/finance/state'
import actions from '~store/modules/finance/actions'

export default {
  state,
  actions
}
